"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockedJWTToken = exports.mockedHostInfo = exports.mockedUser = exports.mockedBuilding = exports.mockedGetTokenizeCard = exports.mockedCompany = exports.mockedBrand = exports.mockedInitialRoute = exports.mockedTheme = exports.base_url = exports.sessionToken = void 0;
exports.sessionToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBfdXVpZCI6ImNiMGQwZjgxLWVhYzQtNDZkNi05YmQ2LTYwNWE2OTkyZjE1OCIsInVzZXJfdXVpZCI6IjFhZjViNDJkLTEyZTctNGU5Yy1iYjRmLWFiMjJiYTQ2Nzc1YiIsIndoaXRlbGFiZWxfdXVpZCI6IjM0ZWI3NmQ1LTc4MmItNGRlYi1iZjY1LTA2ZjkwM2JkYjhjZiIsImJ1aWxkaW5nX3V1aWQiOiI0NjU1MzdjNy05OTljLTQzZGEtYjhkMC00NjYxYmM1MmU4OWQiLCJ2ZXJzaW9uIjoxLCJpYXQiOjE1MTYyMzkwMjJ9.nA8nLyyqaifFIwISWlPDLYEoPCccd8rDHn9CrUNkFtU';
exports.base_url = 'https://hqo.dev';
exports.mockedTheme = {
    primary1: '#ffffff',
    primary2: '#eeeeee',
};
exports.mockedInitialRoute = 'initial-route';
exports.mockedBrand = 'MOCKED_BRAND';
exports.mockedCompany = {
    uuid: '39d49260-718d-4add-add8-e124589d9a1a',
    name: 'HqO',
};
exports.mockedGetTokenizeCard = { card_id: 1795, token: 'PAYMENT_TOKEN' };
exports.mockedBuilding = {
    name: 'Test Building',
    uuid: 'a102770a-5018-40dd-92ae-ae5246dba201',
    address_1: '38 Chauncy St',
    city: 'Boston',
    administrative_area_1: 'MA',
    country_code: 'US',
    theme: exports.mockedTheme,
};
exports.mockedUser = {
    first_name: 'Test',
    last_name: 'User',
    email: 'test@test.com',
    uuid: '5760976f-28ce-441d-8e1a-cce01aa2e21e',
    company: exports.mockedCompany,
};
exports.mockedHostInfo = {
    host: {
        version: exports.base_url,
        theme: exports.mockedTheme,
    },
};
exports.mockedJWTToken = 'MOCKED_JWT';
//# sourceMappingURL=mockedData.js.map